import React, { useEffect } from "react";
import "../App.css";
import Header from "./Header";
import Banner from "./Banner";
import AboutSection from "./AboutSection";
import MdSection from "./MdSection";
import RightSideMenu from "./RightSideMenu";
import Education from "./Education";
import Healthcare from "./Healthcare";
import Sports from "./Sports";
import Hospitality from "./Hospitality";
import MediaSection from "./MediaSection";
import Gallery from "./Gallery";
import Footer from "./Footer";




function Home() {

  useEffect(() => {
    document.body.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = "auto";
    };
  }, []);

  return (
    <div className="scroll-container">
      {/* <RightSideMenu /> */}

      <section className="scroll-section-header menu">
        <Header />
      </section>

      <section>
        <Banner />
      </section>

      <section className="scroll-section" id="about">
        <AboutSection />
      </section>

      <section className="scroll-section mdSection">
        <MdSection />
      </section>

      <section className="scroll-section" id="education">
        <Education />
      </section>

      <section className="scroll-section" id="healthcare">
        <Healthcare />
      </section>

      <section className="scroll-section" id="sports">
        <Sports />
      </section>

      <section className="scroll-section" id="hospitality">
        <Hospitality />
      </section>

      <section className="scroll-section" id="media">
        <MediaSection />
      </section>

      <section className="scroll-section-nor">
        <Gallery />
      </section>

      <section className="scroll-section-nor">
        <Footer />
      </section>

    </div>
  );
}

export default Home;